import React, { useEffect } from "react";
import PublicLayout from "@/components/PublicLayout";

const HERO_IMAGE = "/images/hero.png";
const WHATSAPP_GROUP = "https://chat.whatsapp.com/FTpF0TyZG2nJkWpWKPdlrM?mode=hqrc";
const GOOGLE_REVIEWS = "http://tiny.cc/d6q1101";
const GOOGLE_MAPS_REVIEWS = "https://maps.app.goo.gl/9zfFpfhCeFDPcYac8";

const poppins = { fontFamily: "'Poppins', sans-serif" };

/* ── Animated SVG Icon Components ──────────────────────────────────────────── */

function FlightIcon() {
  return (
    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ overflow: "visible" }}>
      <style>{`
        @keyframes tbfFloat {
          0%, 100% { transform: translateY(0px); }
          50%       { transform: translateY(-8px); }
        }
      `}</style>
      <g style={{ animation: "tbfFloat 3s ease-in-out infinite" }}>
        {/* Fuselage */}
        <path d="M32 6 C34 6 36 8.5 36 12 L36 52 C36 55.5 34 58 32 58 C30 58 28 55.5 28 52 L28 12 C28 8.5 30 6 32 6 Z" fill="#6C3084"/>
        {/* Left wing */}
        <path d="M28 27 L5 40 L5 44 L28 35 Z" fill="#6C3084"/>
        {/* Right wing */}
        <path d="M36 27 L59 40 L59 44 L36 35 Z" fill="#6C3084"/>
        {/* Left tail */}
        <path d="M28 46 L15 53 L15 56 L28 51 Z" fill="#8B52BC"/>
        {/* Right tail */}
        <path d="M36 46 L49 53 L49 56 L36 51 Z" fill="#8B52BC"/>
        {/* Cockpit glint */}
        <ellipse cx="32" cy="13" rx="2" ry="3.5" fill="white" opacity="0.45"/>
      </g>
    </svg>
  );
}

function VisaIcon() {
  return (
    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <style>{`
        @keyframes tbfStamp {
          0%, 100% { transform: scale(0.88); opacity: 0.75; }
          50%       { transform: scale(1.06); opacity: 1; }
        }
      `}</style>
      {/* Passport body */}
      <rect x="12" y="8" width="36" height="48" rx="4" fill="#6C3084"/>
      {/* Cover top band */}
      <rect x="12" y="8" width="36" height="7" rx="4" fill="#5a2580"/>
      {/* Cover decoration lines */}
      <rect x="19" y="22" width="20" height="2.5" rx="1.25" fill="white" opacity="0.45"/>
      <rect x="21" y="27" width="15" height="2" rx="1" fill="white" opacity="0.3"/>
      {/* Photo area */}
      <rect x="15" y="34" width="14" height="16" rx="2" fill="white" opacity="0.15"/>
      {/* Text lines beside photo */}
      <rect x="32" y="36" width="11" height="2" rx="1" fill="white" opacity="0.3"/>
      <rect x="32" y="40" width="9" height="2" rx="1" fill="white" opacity="0.3"/>
      <rect x="32" y="44" width="10" height="2" rx="1" fill="white" opacity="0.3"/>
      {/* Visa stamp — pulses */}
      <g style={{ transformOrigin: "43px 23px", animation: "tbfStamp 2.2s ease-in-out infinite" }}>
        <circle cx="43" cy="23" r="13" fill="none" stroke="#f59e0b" strokeWidth="2.5"/>
        <circle cx="43" cy="23" r="9.5" fill="none" stroke="#f59e0b" strokeWidth="1" strokeDasharray="2.5 2"/>
        {/* VISA lettering as bars */}
        <rect x="37" y="21" width="12" height="2" rx="1" fill="#f59e0b" opacity="0.9"/>
        <rect x="38" y="24" width="10" height="1.5" rx="0.75" fill="#f59e0b" opacity="0.7"/>
      </g>
    </svg>
  );
}

function HotelIcon() {
  return (
    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <style>{`
        @keyframes tbfWinA {
          0%, 100% { fill: #f59e0b; }
          50%       { fill: #fde68a; }
        }
        @keyframes tbfWinB {
          0%, 100% { fill: #fde68a; }
          50%       { fill: #f59e0b; }
        }
        @keyframes tbfWinC {
          0%, 35%  { fill: #f59e0b; }
          65%, 100%{ fill: #fde68a; }
        }
      `}</style>
      {/* Ground strip */}
      <rect x="4" y="57" width="56" height="4" rx="1" fill="#5a2580"/>
      {/* Main building */}
      <rect x="10" y="20" width="44" height="37" rx="2" fill="#6C3084"/>
      {/* Top band */}
      <rect x="10" y="20" width="44" height="6" rx="2" fill="#5a2580"/>
      {/* Penthouse */}
      <rect x="18" y="10" width="28" height="12" rx="2" fill="#6C3084"/>
      {/* Penthouse top */}
      <rect x="25" y="5" width="14" height="7" rx="1.5" fill="#5a2580"/>
      {/* Door */}
      <rect x="24" y="44" width="16" height="13" rx="2" fill="#3d1a5c"/>
      <circle cx="37" cy="51" r="1.5" fill="#8B52BC"/>
      {/* Windows row 1 */}
      <rect x="13" y="28" width="10" height="8" rx="1.5" style={{ animation: "tbfWinA 2.6s ease-in-out infinite" }}/>
      <rect x="27" y="28" width="10" height="8" rx="1.5" style={{ animation: "tbfWinC 2.6s ease-in-out infinite", animationDelay: "0.9s" }}/>
      <rect x="41" y="28" width="10" height="8" rx="1.5" style={{ animation: "tbfWinB 2.6s ease-in-out infinite", animationDelay: "1.7s" }}/>
      {/* Windows row 2 (flanking door) */}
      <rect x="13" y="40" width="10" height="8" rx="1.5" style={{ animation: "tbfWinB 2.6s ease-in-out infinite", animationDelay: "0.5s" }}/>
      <rect x="41" y="40" width="10" height="8" rx="1.5" style={{ animation: "tbfWinA 2.6s ease-in-out infinite", animationDelay: "1.3s" }}/>
    </svg>
  );
}

function PackageIcon() {
  return (
    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ overflow: "visible" }}>
      <style>{`
        @keyframes tbfWobble {
          0%, 100% { transform: rotate(0deg); }
          20%       { transform: rotate(-5deg); }
          40%       { transform: rotate(5deg); }
          60%       { transform: rotate(-2.5deg); }
          80%       { transform: rotate(2.5deg); }
        }
      `}</style>
      <g style={{ animation: "tbfWobble 3s ease-in-out infinite", transformOrigin: "32px 42px" }}>
        {/* Handle arc */}
        <path d="M22 25 Q22 13 32 13 Q42 13 42 25" fill="none" stroke="#5a2580" strokeWidth="4.5" strokeLinecap="round"/>
        {/* Body */}
        <rect x="11" y="25" width="42" height="34" rx="5" fill="#6C3084"/>
        {/* Horizontal strap */}
        <rect x="11" y="38" width="42" height="5" fill="#5a2580"/>
        {/* Left clasp */}
        <rect x="22" y="34" width="9" height="9" rx="2.5" fill="#8B52BC"/>
        {/* Right clasp */}
        <rect x="33" y="34" width="9" height="9" rx="2.5" fill="#8B52BC"/>
        {/* Shine highlight */}
        <rect x="16" y="29" width="13" height="5" rx="2.5" fill="white" opacity="0.12"/>
      </g>
    </svg>
  );
}

function Step1Icon() {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ overflow: "visible" }}>
      <style>{`
        @keyframes tbfScan {
          0%, 100% { transform: translateX(0px) rotate(0deg); }
          33%       { transform: translateX(-5px) rotate(-6deg); }
          66%       { transform: translateX(5px) rotate(6deg); }
        }
      `}</style>
      <g style={{ animation: "tbfScan 2.8s ease-in-out infinite", transformOrigin: "20px 20px" }}>
        <circle cx="20" cy="20" r="14" stroke="#6C3084" strokeWidth="3.5"/>
        <circle cx="20" cy="20" r="8" fill="#6C3084" opacity="0.18"/>
        <line x1="30" y1="30" x2="43" y2="43" stroke="#6C3084" strokeWidth="3.5" strokeLinecap="round"/>
      </g>
    </svg>
  );
}

function Step2Icon() {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <style>{`
        @keyframes tbfFlapOpen {
          0%, 100% { transform: translateY(0px) scaleY(1); }
          45%, 55% { transform: translateY(-7px) scaleY(0.7); }
        }
      `}</style>
      {/* Envelope body */}
      <rect x="4" y="16" width="40" height="27" rx="3" fill="#6C3084"/>
      {/* Bottom fold creases */}
      <line x1="4" y1="43" x2="24" y2="30" stroke="#5a2580" strokeWidth="1.5"/>
      <line x1="44" y1="43" x2="24" y2="30" stroke="#5a2580" strokeWidth="1.5"/>
      {/* Top flap — animated open/close */}
      <polygon
        points="4,16 24,31 44,16"
        fill="#8B52BC"
        style={{ transformOrigin: "24px 16px", animation: "tbfFlapOpen 2.5s ease-in-out infinite" }}
      />
      {/* Letter content lines */}
      <line x1="11" y1="31" x2="25" y2="31" stroke="white" strokeWidth="1.5" strokeLinecap="round" opacity="0.4"/>
      <line x1="11" y1="36" x2="20" y2="36" stroke="white" strokeWidth="1.5" strokeLinecap="round" opacity="0.35"/>
    </svg>
  );
}

function Step3Icon() {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ overflow: "visible" }}>
      <style>{`
        @keyframes tbfSlide {
          0%        { transform: translateX(-10px); opacity: 0.3; }
          30%, 80%  { transform: translateX(0px);  opacity: 1; }
          100%      { transform: translateX(-10px); opacity: 0.3; }
        }
      `}</style>
      <g style={{ animation: "tbfSlide 2.6s ease-in-out infinite" }}>
        {/* Ticket body */}
        <rect x="2" y="12" width="44" height="24" rx="3.5" fill="#6C3084"/>
        {/* Perforation line */}
        <line x1="31" y1="12" x2="31" y2="36" stroke="white" strokeWidth="1.5" strokeDasharray="2.5 2.5" opacity="0.5"/>
        {/* Half-circle notches */}
        <path d="M28 12 A3 3 0 0 1 34 12" fill="white"/>
        <path d="M28 36 A3 3 0 0 0 34 36" fill="white"/>
        {/* Text stubs — left side */}
        <rect x="8" y="18" width="17" height="2.5" rx="1.25" fill="white" opacity="0.7"/>
        <rect x="8" y="23" width="13" height="2" rx="1" fill="white" opacity="0.5"/>
        <rect x="8" y="27.5" width="15" height="2" rx="1" fill="white" opacity="0.4"/>
        {/* Barcode — right side */}
        <rect x="34" y="17" width="3" height="14" rx="1" fill="white" opacity="0.6"/>
        <rect x="38" y="17" width="1.5" height="14" rx="0.75" fill="white" opacity="0.6"/>
        <rect x="40.5" y="17" width="3" height="14" rx="1" fill="white" opacity="0.6"/>
      </g>
    </svg>
  );
}

function StarIcon({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="#f59e0b" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
    </svg>
  );
}

function EmailIcon({ color = "#fff", size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="20" height="16" x="2" y="4" rx="2" stroke={color} strokeWidth="2"/>
      <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" stroke={color} strokeWidth="2"/>
    </svg>
  );
}

function LocationIcon({ color = "#fff", size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" stroke={color} strokeWidth="2"/>
      <circle cx="12" cy="10" r="3" stroke={color} strokeWidth="2"/>
    </svg>
  );
}

/* ── Data ────────────────────────────────────────────────────────────────── */

const STEPS = [
  {
    Icon: Step1Icon,
    title: "Submit Your Request",
    desc: "Fill in your travel details and we'll start searching for the best fares across all airlines.",
  },
  {
    Icon: Step2Icon,
    title: "Receive Your Quote",
    desc: "We'll send you personalised options with transparent pricing within hours — no hidden fees.",
  },
  {
    Icon: Step3Icon,
    title: "Confirm & Fly",
    desc: "Approve your booking, pay securely, and receive your e-ticket directly to your inbox.",
  },
];

const SERVICES_TRAVEL = [
  {
    Icon: FlightIcon,
    title: "Flight Booking",
    desc: "Search and book flights worldwide with access to exclusive fares not always available online.",
  },
  {
    Icon: PackageIcon,
    title: "Complete Travel Packages",
    desc: "Flights + hotels + visa — let us handle everything for one seamless experience.",
  },
];

const SERVICES_EXTRA = [
  {
    Icon: VisaIcon,
    title: "Visa Services",
    desc: "We apply for visas on your behalf for most countries worldwide. From document preparation to submission — we handle the entire process so you don't have to.",
    link: "/visa-request",
    linkLabel: "Request Visa",
  },
  {
    Icon: HotelIcon,
    title: "Hotel Booking",
    desc: "Find and book hotels that complement your travel itinerary at competitive rates.",
  },
];

const REVIEWS = [
  {
    text: "Booked a last-minute flight to Istanbul and The Better Fare found us seats at half the price I found online. Incredible service — will never book any other way.",
    name: "Layla M.",
    date: "March 2026",
  },
  {
    text: "They handled everything — flights, visa letter, even hotel recommendations. Super responsive on WhatsApp, felt like talking to a friend rather than a travel agent.",
    name: "Yusuf A.",
    date: "January 2026",
  },
  {
    text: "Got business class tickets to Dubai for close to the price of economy elsewhere. Honest, fast, and genuinely better fares. Highly recommend.",
    name: "Priya S.",
    date: "February 2026",
  },
  {
    text: "Already used them three times and every booking has been flawless. Quick replies, great prices, zero stress. This is how travel booking should be.",
    name: "Tariq B.",
    date: "April 2026",
  },
];

function StarRow() {
  return (
    <div style={{ display: "flex", gap: "3px" }}>
      {[1, 2, 3, 4, 5].map((i) => <StarIcon key={i} size={18} />)}
    </div>
  );
}

/* ── Page ────────────────────────────────────────────────────────────────── */

export default function HomePage() {
  useEffect(() => { document.title = "The Better Fare | Cheap Flights & Travel Deals"; }, []);

  return (
    <PublicLayout>
      {/* Hero Section */}
      <div className="max-w-6xl mx-auto px-6 pt-12 pb-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h1 style={{ ...poppins, fontWeight: 900, fontSize: "clamp(2rem, 8vw, 3.5rem)", color: "#1a1a1a", lineHeight: 1.1, textTransform: "uppercase", marginBottom: 0 }}>
              EXPLORE
            </h1>
            <h1 style={{ ...poppins, fontWeight: 900, fontSize: "clamp(2rem, 8vw, 3.5rem)", color: "#1a1a1a", lineHeight: 1.1, textTransform: "uppercase", marginBottom: 0 }}>
              THE WONDERS
            </h1>
            <h1 style={{ ...poppins, fontWeight: 900, fontSize: "clamp(2rem, 8vw, 3.5rem)", color: "#6C3084", lineHeight: 1.1, textTransform: "uppercase", marginBottom: "24px" }}>
              OF THE WORLD
            </h1>
            <p className="text-gray-600 leading-relaxed mb-8" style={{ ...poppins, fontSize: "1rem" }}>
              Whether you're seeking a serene escape, a thrilling adventure, or a cultural exploration, we craft personalised travel experiences tailored just for you. Discover the world with us, and let every trip be a story worth sharing.
            </p>
            <a
              href="/flight-request"
              style={{
                display: "inline-block",
                background: "#6C3084",
                color: "#fff",
                ...poppins,
                fontWeight: 600,
                fontSize: "1rem",
                padding: "14px 32px",
                borderRadius: "4px",
                textDecoration: "none",
              }}
            >
              Plan your next adventure
            </a>
          </div>
          <div className="hidden lg:flex justify-center">
            <img src={HERO_IMAGE} alt="Travel illustration" className="w-full max-w-lg" />
          </div>
        </div>
      </div>

      {/* Google Reviews Trust Badge */}
      <div style={{ background: "#fff", borderTop: "1px solid #f0f0f0", borderBottom: "1px solid #f0f0f0", padding: "16px 0" }}>
        <div className="max-w-6xl mx-auto px-6 flex items-center justify-center gap-3 flex-wrap">
          <div style={{ display: "flex", gap: "2px" }}>
            {[1, 2, 3, 4, 5].map((i) => <StarIcon key={i} size={18} />)}
          </div>
          <span style={{ ...poppins, fontWeight: 700, fontSize: "1rem", color: "#1a1a1a" }}>5.0</span>
          <span style={{ ...poppins, fontSize: "0.9rem", color: "#555" }}>— Rated by 76 happy travelers on</span>
          <a
            href={GOOGLE_REVIEWS}
            target="_blank"
            rel="noopener noreferrer"
            style={{ ...poppins, fontWeight: 600, fontSize: "0.9rem", color: "#4285F4", textDecoration: "none" }}
          >
            Google Reviews
          </a>
        </div>
      </div>

      {/* USP Section */}
      <div style={{ background: "#f9f7fc", borderTop: "1px solid #f0f0f0", borderBottom: "1px solid #f0f0f0" }}>
        <div className="max-w-5xl mx-auto px-6 py-16">
          <div className="text-center mb-12">
            <h2 style={{ ...poppins, fontWeight: 900, fontSize: "2rem", color: "#1a1a1a", marginBottom: "12px", textAlign: "center" }}>
              Smarter Flights.{" "}
              <span style={{ color: "#6C3084" }}>Real People.</span>
              {" "}Better Prices.
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
            <div className="bg-white rounded-xl p-6 border border-gray-100 text-center">
              <div className="w-14 h-14 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#6C3084" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/></svg>
              </div>
              <h3 style={{ ...poppins, fontWeight: 700, fontSize: "1rem", color: "#1a1a1a", marginBottom: "8px" }}>We Do the Job</h3>
              <p style={{ ...poppins, fontSize: "0.875rem", color: "#666", textAlign: "center" }}>We compare airlines, routes, dates and nearby airports so you don't have to.</p>
            </div>

            <div className="bg-white rounded-xl p-6 border border-gray-100 text-center">
              <div className="w-14 h-14 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span style={{ fontSize: "28px", fontWeight: 700, color: "#6C3084" }}>€</span>
              </div>
              <h3 style={{ ...poppins, fontWeight: 700, fontSize: "1rem", color: "#1a1a1a", marginBottom: "8px" }}>Better Fares</h3>
              <p style={{ ...poppins, fontSize: "0.875rem", color: "#666", textAlign: "center" }}>We find fares booking sites miss — flexible dates, consolidator prices, hidden routes.</p>
            </div>

            <div className="bg-white rounded-xl p-6 border border-gray-100 text-center">
              <div className="w-14 h-14 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#6C3084" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m22 2-7 20-4-9-9-4Z"/><path d="M22 2 11 13"/></svg>
              </div>
              <h3 style={{ ...poppins, fontWeight: 700, fontSize: "1rem", color: "#1a1a1a", marginBottom: "8px" }}>On Your Finger Tips</h3>
              <p style={{ ...poppins, fontSize: "0.875rem", color: "#666", textAlign: "center" }}>Talk to a real person, not a bot. Reach us directly on WhatsApp — no call centres.</p>
            </div>

            <div className="bg-white rounded-xl p-6 border border-gray-100 text-center">
              <div className="w-14 h-14 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#6C3084" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10"/></svg>
              </div>
              <h3 style={{ ...poppins, fontWeight: 700, fontSize: "1rem", color: "#1a1a1a", marginBottom: "8px" }}>Flight + Visa. Handled.</h3>
              <p style={{ ...poppins, fontSize: "0.875rem", color: "#666", textAlign: "center" }}>Flight + visa assistance in one place. We handle both so you don't have to juggle.</p>
            </div>
          </div>

          <div className="text-center">
            <a
              href="/flight-request"
              style={{
                display: "inline-block",
                background: "#6C3084",
                color: "#fff",
                ...poppins,
                fontWeight: 600,
                fontSize: "1rem",
                padding: "14px 40px",
                borderRadius: "4px",
                textDecoration: "none",
              }}
            >
              Request Your Free Flight Quote
            </a>
            <div className="mt-4">
              <a
                href={WHATSAPP_GROUP}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "8px",
                  color: "#25D366",
                  ...poppins,
                  fontSize: "0.875rem",
                  fontWeight: 600,
                  textDecoration: "none",
                }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="#25D366"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z"/></svg>
                Join our WhatsApp Group
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* How It Works */}
      <div style={{ background: "#fff" }}>
        <div className="max-w-5xl mx-auto px-6 py-16">
          <div className="text-center mb-12">
            <h2 style={{ ...poppins, fontWeight: 900, fontSize: "2rem", color: "#1a1a1a", marginBottom: "12px" }}>
              How It <span style={{ color: "#6C3084" }}>Works</span>
            </h2>
            <p style={{ ...poppins, fontSize: "1rem", color: "#666" }}>Three simple steps to your perfect flight</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {STEPS.map(({ Icon, title, desc }, idx) => (
              <React.Fragment key={title}>
                <div className="bg-white rounded-xl border border-gray-100 tbf-step-card" style={{ boxShadow: "0 2px 12px rgba(108,48,132,0.06)" }}>
                  <div className="tbf-step-icon" style={{ display: "flex", alignItems: "center", justifyContent: "center", width: 72, height: 72, borderRadius: 16, background: "#f3e8ff", position: "relative" }}>
                    <Icon />
                    <div style={{ position: "absolute", top: -8, right: -8, width: 22, height: 22, borderRadius: "50%", background: "#6C3084", display: "flex", alignItems: "center", justifyContent: "center" }}>
                      <span style={{ ...poppins, fontWeight: 800, fontSize: "0.7rem", color: "#fff" }}>{idx + 1}</span>
                    </div>
                  </div>
                  <div>
                    <h3 style={{ ...poppins, fontWeight: 700, fontSize: "1rem", color: "#1a1a1a", marginBottom: "10px" }}>{title}</h3>
                    <p style={{ ...poppins, fontSize: "0.875rem", color: "#666", lineHeight: 1.6 }}>{desc}</p>
                  </div>
                </div>
                {idx < STEPS.length - 1 && (
                  <div className="tbf-step-arrow">↓</div>
                )}
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>

      {/* Services Section */}
      <div style={{ background: "#f9f7fc", borderTop: "1px solid #f0f0f0", borderBottom: "1px solid #f0f0f0" }}>
        <div className="max-w-5xl mx-auto px-6 py-16">
          <div className="text-center mb-12">
            <h2 style={{ ...poppins, fontWeight: 900, fontSize: "2rem", color: "#1a1a1a", marginBottom: "12px" }}>
              Our <span style={{ color: "#6C3084" }}>Services</span>
            </h2>
            <p style={{ ...poppins, fontSize: "1rem", color: "#666" }}>Everything you need for a seamless journey</p>
          </div>

          {[
            { label: "Flights & Travel", items: SERVICES_TRAVEL },
            { label: "Additional Services", items: SERVICES_EXTRA },
          ].map(({ label, items }, groupIdx) => (
            <div key={label} className={groupIdx === 0 ? "mb-8" : ""}>
              <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 20 }}>
                <div style={{ flex: 1, height: 1, background: "#e9d5ff" }} />
                <span style={{ ...poppins, fontSize: "0.7rem", fontWeight: 700, color: "#9333ea", textTransform: "uppercase", letterSpacing: "1.5px", whiteSpace: "nowrap" }}>{label}</span>
                <div style={{ flex: 1, height: 1, background: "#e9d5ff" }} />
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {items.map(({ Icon, title, desc, link, linkLabel }) => (
                  <div key={title} className="bg-white rounded-xl p-6 border border-gray-100 flex gap-5 items-start" style={{ boxShadow: "0 2px 12px rgba(108,48,132,0.04)" }}>
                    <div style={{ width: 72, height: 72, borderRadius: 16, background: "#f3e8ff", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                      <Icon />
                    </div>
                    <div style={{ paddingTop: 4 }}>
                      <h3 style={{ ...poppins, fontWeight: 700, fontSize: "1rem", color: "#1a1a1a", marginBottom: "6px" }}>{title}</h3>
                      <p style={{ ...poppins, fontSize: "0.875rem", color: "#666", lineHeight: 1.6, marginBottom: link ? "12px" : 0 }}>{desc}</p>
                      {link && (
                        <a href={link} style={{ ...poppins, fontSize: "0.8rem", fontWeight: 700, color: "#6C3084", textDecoration: "none", display: "inline-flex", alignItems: "center", gap: "4px" }}>
                          {linkLabel} →
                        </a>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Customer Reviews */}
      <div style={{ background: "#fff" }}>
        <div className="max-w-5xl mx-auto px-6 py-16">
          <div className="text-center mb-12">
            <h2 style={{ ...poppins, fontWeight: 900, fontSize: "2rem", color: "#1a1a1a", marginBottom: "12px" }}>
              What Our <span style={{ color: "#6C3084" }}>Travelers Say</span>
            </h2>
            <p style={{ ...poppins, fontSize: "1rem", color: "#666" }}>Real reviews from real customers</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10">
            {REVIEWS.map(({ text, name, date }) => (
              <div
                key={name}
                className="bg-white rounded-xl p-6 border border-gray-100"
                style={{ boxShadow: "0 2px 12px rgba(108,48,132,0.06)" }}
              >
                <StarRow />
                <p style={{ ...poppins, fontSize: "0.9rem", color: "#444", lineHeight: 1.7, margin: "14px 0 16px" }}>
                  "{text}"
                </p>
                <p style={{ ...poppins, fontSize: "0.8rem", fontWeight: 700, color: "#6C3084" }}>
                  — {name}, <span style={{ fontWeight: 400, color: "#888" }}>{date}</span>
                </p>
              </div>
            ))}
          </div>

          <div className="text-center">
            <a
              href={GOOGLE_MAPS_REVIEWS}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "8px",
                border: "2px solid #6C3084",
                color: "#6C3084",
                ...poppins,
                fontWeight: 600,
                fontSize: "0.95rem",
                padding: "12px 28px",
                borderRadius: "4px",
                textDecoration: "none",
              }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#6C3084" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/></svg>
              See all reviews on Google
            </a>
          </div>
        </div>
      </div>

      {/* Contact Bar */}
      <div style={{ background: "#6C3084" }}>
        <div className="max-w-5xl mx-auto px-6 py-10">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6 flex-wrap">
            <div className="flex flex-col md:flex-row items-center gap-6 flex-wrap">
              <a
                href="mailto:info@thebetterfare.com"
                style={{ display: "inline-flex", alignItems: "center", gap: "8px", color: "#fff", ...poppins, fontSize: "0.95rem", fontWeight: 500, textDecoration: "none" }}
              >
                <EmailIcon color="#fff" size={18} />
                info@thebetterfare.com
              </a>
              <span style={{ display: "inline-flex", alignItems: "center", gap: "8px", color: "#fff", ...poppins, fontSize: "0.95rem", fontWeight: 500 }}>
                <LocationIcon color="#fff" size={18} />
                Arnhem, Netherlands
              </span>
            </div>
            <a
              href={WHATSAPP_GROUP}
              target="_blank"
              rel="noopener noreferrer"
              style={{ display: "inline-flex", alignItems: "center", gap: "8px", background: "#25D366", color: "#fff", ...poppins, fontWeight: 600, fontSize: "0.95rem", padding: "11px 24px", borderRadius: "4px", textDecoration: "none" }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="#fff"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z"/></svg>
              Chat on WhatsApp
            </a>
          </div>
        </div>
      </div>
    </PublicLayout>
  );
}
